import { BffResourceResponse } from '@actiris/bff';
import { ApiManyResponse, ApiOneResponse, cacheable, many, one } from '@actiris/forms';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Profile } from '@core/models/api/access-request/profile';
import { Observable } from 'rxjs';
import { AccessRequestDTO } from '../../models/api/access-request/access-request-dto';
import { AccountSearchResultDTO } from '../../models/api/access-request/account-search-result-dto';
import { ApplicationRole } from '../../models/api/access-request/application-role';

@Injectable({
    providedIn: 'root',
})
export class MyAccountApiService {
    private http = inject(HttpClient);
    private urlBase = '/api/my-account';

    @cacheable()
    searchColleagues(search: string, amount: number): Observable<AccountSearchResultDTO> {
        return this.http
            .post<ApiOneResponse<AccountSearchResultDTO>>(`${this.urlBase}/search`, { search, page: 0, nombreElements: amount })
            .pipe(one());
    }

    @cacheable()
    getRoles(language: string): Observable<ApplicationRole[]> {
        return this.http.get<ApiManyResponse<ApplicationRole>>(`${this.urlBase}/roles/${language}`).pipe(many());
    }

    createAccessRequest(request: AccessRequestDTO): Observable<void> {
        return this.http.post<void>(`${this.urlBase}/roles-request`, request);
    }

    getConnectedUserInfo(): Observable<Profile> {
        return this.http.get<ApiOneResponse<Profile>>(`${this.urlBase}/user-info`).pipe(one());
    }

    updateDisplayName(newDisplayName: string): Observable<void> {
        return this.http.post<void>(`${this.urlBase}/update-appellation`, { nouvelleAppellation: newDisplayName });
    }

    updatePassword(request: { nouveauMotDePasse: string; ancienMotDePasse: string }): Observable<void> {
        return this.http.post<void>(`${this.urlBase}/update-password`, request);
    }

    updateEmail(request: { nouvelEmail: string; password: string }): Observable<void> {
        return this.http.post<void>(`${this.urlBase}/update-email`, request);
    }

    permissions(): Observable<BffResourceResponse[]> {
        return this.http.get<ApiManyResponse<BffResourceResponse>>(`${this.urlBase}/permissions`).pipe(many());
    }
}
